import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";

export interface GenericDataListItem {
  label: string | undefined;
  value: string | number | undefined;
  valueOnNewLine?: boolean;
  whitespaceTop?: boolean;
  whitespaceBottom?: boolean;
  whitespaceLeft?: boolean;
}

@Component({
  selector: "pa-generic-data-table",
  templateUrl: "./generic-data-table.component.html",
  styleUrls: ["./generic-data-table.component.scss"],
  imports: [NgClass],
})
export class GenericDataTableComponent {
  @Input() list: GenericDataListItem[] | undefined;
}
